import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../hooks/Language';

import { Container } from './styles';

const Logo: React.FC = () => {

  const { language } = useLanguage();
  const [logoValue, setLogoValue] = useState("/apoio/logo-padrao2.png");


  useEffect(() => {

    const validLogo = {
      ptBr: "/apoio/logo-padrao2.png",
      en: "/apoio/logo-padrao2.png",
      es: "/apoio/logo-padrao2.png",
    }


    setLogoValue(validLogo?.[language] ? validLogo[language] : logoValue);

  }, [language])

  return (
    <Container>
      <img src={logoValue} />
    </Container>
  );
};
export default Logo;
